export interface AnimeItem {
  id: string;
  title: string;
  tags: string[];
  score: number;
  status: string;
  episodes: string;
  desc: string;
  image: string;
}

export interface CategoryItem {
  id: string;
  name: string;
  tag: string;
  desc: string;
  image: string;
}

export interface TimelineItem {
  day: string;
  title: string;
  tag: string;
  time: string;
}

export const heroImage =
  "https://readdy.ai/api/search-image?query=Romantic%20anime%20key%20visual%20with%20soft%20warm%20coral%20and%20golden%20twilight%20sky%2C%20silhouettes%20of%20a%20couple%20under%20blooming%20cherry%20trees%2C%20dreamy%20bokeh%20lights%2C%20heart%20shapes%20floating%2C%20cinematic%20lighting%2C%20vibrant%20illustration%20style%20for%20romance%20anime%20website%2C%20high%20detail%20and%20warm%20atmosphere&width=1600&height=900&seq=hero-main-01&orientation=landscape";

export const categoryData: CategoryItem[] = [
  {
    id: "harem",
    name: "后宫恋爱",
    tag: "后宫",
    desc: "多女主线并肩展开，桃花运爆棚，在误会与心动之间游走的恋爱喜剧。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20handsome%20male%20lead%20surrounded%20by%20multiple%20colorful%20female%20characters%20in%20a%20school%20courtyard%2C%20warm%20coral%20and%20gold%20palette%2C%20playful%20romantic%20comedy%20atmosphere%2C%20soft%20afternoon%20light%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=cat-harem-01&orientation=landscape",
  },
  {
    id: "reverse",
    name: "逆后宫",
    tag: "逆后宫",
    desc: "男主作为被攻略对象，坐拥多位高人气角色的追逐与守护，甜度拉满。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20one%20heroine%20surrounded%20by%20several%20charming%20male%20characters%20in%20romantic%20garden%20setting%2C%20warm%20peach%20and%20gold%20tone%2C%20reverse%20harem%20romance%20atmosphere%2C%20soft%20glow%20lighting%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=cat-reverse-01&orientation=landscape",
  },
  {
    id: "sweet",
    name: "暧昧攻略",
    tag: "暧昧",
    desc: "从不挑明到暗流涌动，一步步靠近的攻略剧情，最适合慢慢嗑的观众。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20two%20teenagers%20close%20together%20sharing%20a%20headphone%20under%20warm%20sunset%20sky%2C%20ambiguous%20romance%20mood%2C%20coral%20and%20amber%20tones%2C%20soft%20bokeh%2C%20tender%20atmosphere%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=cat-ambiguous-01&orientation=landscape",
  },
  {
    id: "daily",
    name: "高甜日常",
    tag: "高甜",
    desc: "平凡日常里的心动瞬间，没有大起大落，只有恰到好处的糖分补给。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20sweet%20couple%20making%20lunch%20together%20in%20a%20cozy%20warm%20kitchen%2C%20everyday%20romance%20slice%20of%20life%2C%20peach%20and%20gold%20palette%2C%20soft%20morning%20light%2C%20comforting%20atmosphere%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=cat-daily-01&orientation=landscape",
  },
  {
    id: "classic",
    name: "经典神作",
    tag: "经典",
    desc: "被反复重温的恋爱番标杆，无论何时入坑都不会失望的传世之作。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20romantic%20couple%20standing%20on%20a%20hill%20overlooking%20a%20golden%20city%20at%20dusk%2C%20nostalgic%20classic%20romance%20mood%2C%20warm%20amber%20and%20coral%20tones%2C%20cinematic%20lighting%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=800&height=500&seq=cat-classic-01&orientation=landscape",
  },
];

export const animeList: AnimeItem[] = [
  {
    id: "sakura-covenant",
    title: "樱色契约",
    tags: ["后宫", "恋爱", "高甜"],
    score: 9.4,
    status: "连载中",
    episodes: "更新至 12 话",
    desc: "转学生意外与三位性格迥异的青梅竹马重逢，一份尘封多年的约定让误会与心动同时爆发。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20romantic%20boy%20with%20three%20female%20characters%20under%20cherry%20blossoms%2C%20warm%20coral%20and%20pink%20palette%2C%20harem%20romance%20genre%2C%20soft%20light%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-sakura-01&orientation=portrait",
  },
  {
    id: "star-night-letter",
    title: "星夜告白信",
    tags: ["暧昧", "攻略", "恋爱"],
    score: 9.1,
    status: "完结",
    episodes: "全 12 话",
    desc: "一封寄错地址的情书，把两个同班同学的暗恋推到了明面，攻略与被攻略的游戏悄然开始。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20shy%20girl%20holding%20a%20love%20letter%20under%20a%20starlit%20night%20sky%2C%20ambiguous%20romance%20mood%2C%20warm%20amber%20and%20purple%20free%20coral%20tones%2C%20soft%20moonlight%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-star-01&orientation=portrait",
  },
  {
    id: "academy-reverse",
    title: "学园逆转物语",
    tags: ["逆后宫", "恋爱"],
    score: 8.8,
    status: "连载中",
    episodes: "更新至 8 话",
    desc: "转进贵族学园的女主，身边聚集了王子、剑客与学霸三大人气角色，一场温柔的逆后宫就此展开。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20heroine%20surrounded%20by%20three%20handsome%20male%20characters%20in%20a%20prestigious%20academy%2C%20reverse%20harem%20genre%2C%20warm%20gold%20and%20cream%20palette%2C%20romantic%20atmosphere%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-academy-01&orientation=portrait",
  },
  {
    id: "spring-simulator",
    title: "恋爱模拟器:春日",
    tags: ["高甜", "恋爱", "后宫"],
    score: 9.0,
    status: "完结",
    episodes: "全 13 话",
    desc: "误入恋爱模拟世界的男主，必须在春天结束前做出选择，每个选项都通往不同的心动结局。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20game%20style%20romance%20world%20with%20a%20boy%20and%20multiple%20selectable%20heroines%2C%20warm%20coral%20and%20peach%20tones%2C%20playful%20game%20romance%20genre%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-simulator-01&orientation=portrait",
  },
  {
    id: "dusk-cafe",
    title: "黄昏咖啡厅的邂逅",
    tags: ["暧昧", "攻略"],
    score: 8.6,
    status: "连载中",
    episodes: "更新至 10 话",
    desc: "在打烊前的黄昏咖啡厅，两位常客的每一次偶遇都让彼此的心意愈发清晰。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20couple%20meeting%20in%20a%20cozy%20cafe%20at%20dusk%2C%20ambiguous%20slow%20burn%20romance%2C%20warm%20amber%20lighting%2C%20cream%20and%20gold%20palette%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-dusk-01&orientation=portrait",
  },
  {
    id: "hundred-loves",
    title: "百恋千愿",
    tags: ["后宫", "恋爱"],
    score: 9.2,
    status: "完结",
    episodes: "全 24 话",
    desc: "为实现家族许下的百恋千愿，男主踏上收集心动与羁绊的旅程，命运的桃花越积越多。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20male%20lead%20walking%20through%20a%20magical%20garden%20with%20floating%20glowing%20hearts%2C%20harem%20romance%20fantasy%2C%20warm%20coral%20and%20gold%20tones%2C%20epic%20yet%20romantic%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-hundred-01&orientation=portrait",
  },
  {
    id: "cloud-love-letter",
    title: "云端之上的情书",
    tags: ["逆后宫", "暧昧"],
    score: 8.9,
    status: "连载中",
    episodes: "更新至 9 话",
    desc: "生活在云端城邦的少女，同时收到来自天文学家、剑士与医生的三封告白信，真相逐渐浮出水面。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20girl%20on%20a%20floating%20sky%20city%20with%20three%20male%20suitors%2C%20reverse%20harem%20fantasy%20romance%2C%20warm%20peach%20and%20gold%20palette%2C%20dreamy%20clouds%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-cloud-01&orientation=portrait",
  },
  {
    id: "heartbeat-electives",
    title: "心动选修课",
    tags: ["高甜", "攻略"],
    score: 8.7,
    status: "完结",
    episodes: "全 12 话",
    desc: "开学季的恋爱选修课，从第一节课的相视一笑开始，甜度层层升级的校园攻略物语。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20couple%20sitting%20together%20in%20a%20sunny%20classroom%2C%20sweet%20school%20romance%2C%20warm%20coral%20and%20cream%20tones%2C%20bright%20sunlight%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-electives-01&orientation=portrait",
  },
  {
    id: "summer-reply",
    title: "夏色回信",
    tags: ["恋爱", "暧昧"],
    score: 8.5,
    status: "连载中",
    episodes: "更新至 6 话",
    desc: "漫长的暑假里，一段跨越城镇的笔友通信，让两颗未说出口的心越靠越近。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20boy%20writing%20a%20letter%20by%20a%20sunlit%20window%20in%20summer%2C%20letter%20romance%20genre%2C%20warm%20golden%20afternoon%20light%2C%20coral%20and%20cream%20palette%2C%20nostalgic%20mood%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-summer-01&orientation=portrait",
  },
  {
    id: "city-guide",
    title: "都市攻略手札",
    tags: ["攻略", "恋爱", "后宫"],
    score: 8.8,
    status: "完结",
    episodes: "全 13 话",
    desc: "在繁忙都市里经营咖啡店的男主，意外成为几位熟客女孩的恋爱军师，却慢慢发现自己也身陷其中。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20barista%20with%20several%20female%20customers%20in%20a%20modern%20city%20cafe%2C%20urban%20romance%20harem%2C%20warm%20amber%20and%20coral%20tones%2C%20city%20night%20glow%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-city-01&orientation=portrait",
  },
  {
    id: "moonlight-confession",
    title: "月光下的告白",
    tags: ["暧昧", "逆后宫"],
    score: 8.4,
    status: "连载中",
    episodes: "更新至 7 话",
    desc: "月圆之夜的舞会上，一次打赌式的告白把女主推向风暴中心，多位角色心绪暗涌。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20heroine%20in%20an%20elegant%20ballroom%20under%20moonlight%20with%20multiple%20male%20suitors%2C%20reverse%20harem%20romance%2C%20warm%20gold%20and%20cream%20palette%2C%20romantic%20night%20atmosphere%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-moonlight-01&orientation=portrait",
  },
  {
    id: "heartbeat-cooking",
    title: "心动料理的约定",
    tags: ["高甜", "恋爱"],
    score: 8.9,
    status: "完结",
    episodes: "全 12 话",
    desc: "每天一起做便当的约定，让两个不善言辞的人把所有心意都悄悄藏进了料理里。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20poster%20of%20a%20couple%20cooking%20together%20with%20steaming%20warm%20lunchboxes%2C%20sweet%20food%20romance%2C%20warm%20peach%20and%20gold%20tones%2C%20cozy%20kitchen%20lighting%2C%20vibrant%20anime%20illustration%20style%2C%20high%20detail&width=600&height=800&seq=anime-cooking-01&orientation=portrait",
  },
];

export const featurePosts = [
  {
    id: "reverse-guide",
    title: "逆后宫入坑指南：被追逐的甜蜜",
    tag: "攻略专题",
    excerpt: "从入门到上头，梳理逆后宫番的经典套路与人设看点，帮你快速找到第一部入坑作。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20girl%20with%20several%20male%20characters%20competing%20for%20attention%20in%20warm%20garden%2C%20reverse%20harem%20guide%20banner%2C%20coral%20and%20gold%20palette%2C%20vibrant%20anime%20style%2C%20high%20detail&width=800&height=600&seq=feat-reverse-01&orientation=landscape",
  },
  {
    id: "ambiguous-manual",
    title: "暧昧攻略进阶手册",
    tag: "恋爱解读",
    excerpt: "不挑明才有张力，盘点那些教科书级别的暧昧名场面，教你嗑出最佳姿势。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20two%20people%20almost%20touching%20hands%20under%20warm%20sunset%2C%20ambiguous%20romance%20guide%20banner%2C%20amber%20and%20coral%20tones%2C%20vibrant%20anime%20style%2C%20high%20detail&width=800&height=600&seq=feat-ambiguous-01&orientation=landscape",
  },
  {
    id: "daily-list",
    title: "高甜日常补番清单",
    tag: "补番推荐",
    excerpt: "需要回血就来看高甜日常，这份清单里的每部都甜而不腻，适合一口气刷完。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sweet%20couple%20picnicking%20under%20a%20warm%20sunny%20sky%2C%20slice%20of%20life%20romance%20banner%2C%20peach%20and%20gold%20palette%2C%20vibrant%20anime%20style%2C%20high%20detail&width=800&height=600&seq=feat-daily-01&orientation=landscape",
  },
  {
    id: "from-zero",
    title: "从零开始的恋爱番指南",
    tag: "新手入门",
    excerpt: "第一次接触恋爱番？这份从选番到追更的全流程指南，让你轻松上手不迷路。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20beginner%20viewer%20with%20a%20map%20and%20glowing%20hearts%20path%2C%20beginner%20romance%20guide%20banner%2C%20warm%20coral%20and%20cream%20tones%2C%20vibrant%20anime%20style%2C%20high%20detail&width=800&height=600&seq=feat-zero-01&orientation=landscape",
  },
];

export const timelineData: TimelineItem[] = [
  { day: "周一", title: "云端之上的情书", tag: "逆后宫", time: "21:00" },
  { day: "周二", title: "心动选修课", tag: "高甜", time: "22:00" },
  { day: "周三", title: "樱色契约", tag: "后宫", time: "21:30" },
  { day: "周四", title: "学园逆转物语", tag: "逆后宫", time: "23:00" },
  { day: "周五", title: "黄昏咖啡厅的邂逅", tag: "暧昧", time: "20:30" },
  { day: "周六", title: "都市攻略手札", tag: "攻略", time: "22:30" },
  { day: "周日", title: "月光下的告白", tag: "暧昧", time: "21:00" },
];

export const faqs = [
  {
    q: "女神动漫上的推荐真的可靠吗？",
    a: "我们的每一条推荐都经过对剧情、人设、节奏和口碑的综合筛选，覆盖后宫、恋爱、暧昧、攻略、逆后宫等多种题材，并会持续根据观众反馈更新榜单，帮你避开烂番、快速找到合口味的好作品。",
  },
  {
    q: "如何快速找到我喜欢的题材？",
    a: "你可以在首屏使用站内搜索，也可以点击首页的题材分类标签（后宫恋爱、逆后宫、暧昧攻略、高甜日常、经典神作），系统会立即为你筛选出对应分类下的全部作品，定位又快又准。",
  },
  {
    q: "推荐内容会持续更新吗？",
    a: "会的。我们会紧跟每季新番动态，及时把值得追的高甜、暧昧与逆后宫新作补充进榜单，并在追番时间表中同步更新连载进度，让你追更不再迷路。",
  },
  {
    q: "有没有专门针对逆后宫向的推荐？",
    a: "当然有。在题材分类中点击「逆后宫」即可查看全部被追逐向作品，专题攻略里也有「逆后宫入坑指南」，从人设到剧情帮你梳理清楚，入坑毫无压力。",
  },
  {
    q: "我可以在站内发表自己的推荐吗？",
    a: "目前我们以编辑整理推荐为主，也欢迎你在「关于本站」的联系方式中与我们交流你的心头好，优质冷门佳作有机会被收录进下一轮榜单。",
  },
];